import React, { useEffect } from "react";
import { Layout } from "antd";
import { Outlet } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { CONSTANT } from "../../../config/Constant";

const AuthLayout = () => {
  const navigate = useNavigate();
  const { token } = useSelector((state) => state.auth);

  useEffect(() => {
    if (token) {
      navigate(CONSTANT.DASHBOARD_REDIRECT_PATH);
    }
  }, [token, navigate]);

  return !token ? (
    <Layout className={`main__page__wrapper`}>
      <Outlet />
    </Layout>
  ) : null;
};

export default AuthLayout;
